import { InputAdornment, TextField, Typography, Stack } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { NumberOfChannelsDropdown } from "../NumberOfChannelsDropdown";
import { RecordingDeviceType } from "./RecordingDeviceType";
import { INT16 } from "../../pages/app/utils/constants";

export const FileDetailsInt16Type = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Stack gap={2}>
      <RecordingDeviceType />
      <Controller
        name="fileType"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="File Type"
            slotProps={{ htmlInput: { readOnly: true } }}
          />
        )}
      />
      <Controller
        name="display"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Bit Format"
            slotProps={{ htmlInput: { readOnly: true } }}
          />
        )}
      />
      <Controller
        name="sampleRate"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label="Sample Rate"
            type="number"
            error={!!errors.sampleRate}
            helperText={
              errors.sampleRate
                ? errors.sampleRate.message
                : "Please enter the sample rate in Hz."
            }
            slotProps={{
              htmlInput: { min: 0, step: 0.5 },
              input: {
                endAdornment: (
                  <InputAdornment position="end">Hz</InputAdornment>
                ),
              },
            }}
          />
        )}
      />
      <NumberOfChannelsDropdown fileType={INT16} />
      <Typography variant="caption" color="text.secondary">
        If you have the accompanying JSON file, you can drag it to the file
        upload section to determine the number of channels automatically.
      </Typography>
    </Stack>
  );
};
